/** The event GlobalSearchBar listens for to open the search from elsewhere. */
export const OPEN_GLOBAL_SEARCH_EVENT = 'arvoke:open-global-search'

export interface OpenGlobalSearchDetail {
  /** What the search box starts with. */
  query: string
}

/**
 * Opens the header's search (as Ctrl+K does) with `query` already typed: the
 * sidebar's search hands what it couldn't find to the search of everything.
 */
export function openGlobalSearch(query: string) {
  window.dispatchEvent(
    new CustomEvent<OpenGlobalSearchDetail>(OPEN_GLOBAL_SEARCH_EVENT, { detail: { query } })
  )
}
